
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onMounted,
  computed,
  watch,
  nextTick
} from 'vue'
import Nodata from '@/components/page/nodata.vue'

export default defineComponent({
  components: { Nodata },
  props: {
    spinning: {
      type: Boolean,
      default: true
    },
    emptyInfo: {
      type: String,
      default: '暂无数据'
    }
  },
  setup(props, context) {
    const pageData: any = reactive({})

    return {
      ...toRefs(pageData)
    }
  }
})
